module.exports = __webpack_public_path__ + "static/media/20240207165423_IMG_5310.0287c71b.JPG";